// extracted by mini-css-extract-plugin
export default {"layout-grid":"GeneratedForm_layout-grid__Ce9JR"};